import React from 'react';
import { Typography } from 'antd';

import EmptyC from 'src/components/Layout/Empty';

const ErrorNetwork = () => {
	return (
		<div className="p-6">
			<EmptyC
				image={'/icons/error-network.svg'}
				imageWidth={130}
				imageHeight={130}
				title={
					<Typography.Title level={5} className="fw-600 fs-16 fs-md-18 text-neutral-3">
						Sedang Gangguan Jaringan
					</Typography.Title>
				}
				description={
					<Typography.Paragraph className="text-neutral-7 fs-14 ls-1">
						Ada ganguan jaringan nih, coba refresh page ini yah
					</Typography.Paragraph>
				}
				buttonHidden={true}
				buttonText=""
				className="p-6"
			/>
		</div>
	);
};

export default ErrorNetwork;
